/** Sentinel of a filter that is not narrowing anything. */
export const ALL_FILTER = 'all';

export const RECEIPT_STATUS = {
  PENDING: 'pending',
  PARTIAL: 'partial',
  RECEIVED: 'received',
  CANCELLED: 'cancelled',
};

/** The order the statuses are walked in, which is the order of the chips. */
export const RECEIPT_STATUS_ORDER = [
  RECEIPT_STATUS.PENDING,
  RECEIPT_STATUS.PARTIAL,
  RECEIPT_STATUS.RECEIVED,
  RECEIPT_STATUS.CANCELLED,
];

/**
 * What each status asks for: amber is "something arrived and something is
 * still missing", green is done, grey is waiting, red is undone.
 */
export const RECEIPT_STATUS_TONES = {
  [RECEIPT_STATUS.PENDING]: 'neutral',
  [RECEIPT_STATUS.PARTIAL]: 'warning',
  [RECEIPT_STATUS.RECEIVED]: 'success',
  [RECEIPT_STATUS.CANCELLED]: 'danger',
};

/**
 * Where a receipt came from, which whoever created it decides: the WMS
 * screens, or a sales channel that synced its stock. The filter offers the
 * ones that can come today; a channel joins when it syncs stock.
 */
export const RECEIPT_SOURCE_OPTIONS = [
  { value: 'wms', label: 'WMS Ninja' },
  { value: 'shopify', label: 'Shopify' },
];

/** A line of the declaration before anything is typed. */
export const EMPTY_RECEIPT_LINE = { productId: null, expected: 1, lot: '', expiry_date: '' };

/** The columns of the bulk sheet. `Referencia` groups rows into one order. */
export const RECEIPTS_TEMPLATE_COLUMNS = [
  'Referencia',
  'SKU',
  'Cantidad',
  'Lote',
  'Vence',
  'Proveedor',
  'Notas',
];

/** Two references on purpose, so the sheet shows how rows become orders. */
export const RECEIPTS_TEMPLATE_EXAMPLE = [
  { Referencia: 'G-1001', SKU: 'POL-001', Cantidad: 50, Lote: '', Vence: '', Proveedor: 'Transportes Sur', Notas: '' },
  { Referencia: 'G-1001', SKU: 'TAZ-010', Cantidad: 20, Lote: 'L-A', Vence: '2027-01-15', Proveedor: '', Notas: '' },
  { Referencia: 'G-1002', SKU: 'POL-001', Cantidad: 10, Lote: '', Vence: '', Proveedor: 'Otro transporte', Notas: 'urgente' },
];
